import React from 'react';

import CustomToaster from '@components/CustomToaster';

import ProfileDetail from './ProfileDetail';

const SubscriberProfile = () => {
  return (
    <>
      <ProfileDetail />
      <CustomToaster />
    </>
  );
};

export default SubscriberProfile;
